import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";

export const NoteInformation = ({ title, description, className }: { title: string | JSX.Element; description: string; className?: string }) => {
	return (
		<Row className={`rounded-xl p-5 ${className}`}>
			<TextComponent variant="h6">
				{typeof title === "string" ? (
					<>
						<span className="text-black font-semibold">{title}</span> {description}
					</>
				) : (
					<Row
						crossAxisAlignment="center"
						className="gap-2 max-lg:flex-col max-lg:items-start"
					>
						{title} {description}
					</Row>
				)}
			</TextComponent>
		</Row>
	);
};
